export class UiProgramSettingsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSettings() {
    return this.#http.get('/api/ui-programs-settings');
  }

  async editSettings({ ...body }) {
    return this.#http.put('/api/ui-programs-settings', body);
  }
}
